(function ($) {
  $(document).ready(function () {
    $(document).on("click", "button.btnAddToCart", function (event) {
      event.preventDefault();
      var $button = $(this);
      var $form = $button.closest("form");
      var mainProductData = $form.serializeArray();
      var upsellProducts = getSelectedUpsells();

      // First, add the main product
      addToCart(mainProductData, function () {
        // Then, add the selected upsell products
        if (upsellProducts.length > 0) {
          addUpsellProducts(upsellProducts);
        } else {
          updateMiniCart(); // Update cart if no upsells
        }
      });
    });

    // Function to get selected upsell products with their selected variants
    function getSelectedUpsells() {
      var selectedUpsells = [];
      $(".upsell-checkbox:checked").each(function () {
        var productId = $(this).data("product-id");
        var variantSelect = $("#upsell-variant-" + productId);
        var variantId = variantSelect.length
          ? variantSelect.val()
          : $(this).siblings("input[name='upsell-variant']").val();

        if (variantId) {
          selectedUpsells.push(variantId);
        }
      });
      return selectedUpsells;
    }

    // Function to add product to cart
    function addToCart(data, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $.param(data),
        dataType: "json",
        success: function (response) {
          console.log("Main product added:", response);
          if (callback) callback();
        },
        error: function (error) {
          console.error("Error adding main product:", error);
        },
      });
    }

    // Function to add upsell products recursively
    function addUpsellProducts(upsellProducts) {
      if (!upsellProducts.length) {
        updateMiniCart();
        return;
      }

      var upsellProductId = upsellProducts.shift();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { quantity: 1, id: upsellProductId },
        dataType: "json",
        success: function (response) {
          console.log("Upsell product added:", response);
          addUpsellProducts(upsellProducts); // Add remaining upsells
        },
        error: function (error) {
          console.error("Error adding upsell product:", error);
        },
      });
    }

    // Function to update the mini cart after all additions
    function updateMiniCart() {
      $.get("/cart?view=json", function (cart) {
        $("#cart-info").html(cart);
      }).always(function () {
        Currency.convertAll(
          shopCurrency,
          $("#currencies span.selected").attr("data-currency")
        );
      });
    }

    // on click #mobile-btn_search focus on search input .aa-MainContainer
    $("#mobile-btn_search").click(function () {
      $(".aa-MainContainer").focus();
      console.log("clicked");
    });
  });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  function updateStockLabels() {
    document.querySelectorAll(".ais-RefinementList-label").forEach((label) => {
      if (label.textContent.includes("true")) {
        label.innerHTML = label.innerHTML.replace("true", "In Stock");
      } else if (label.textContent.includes("false")) {
        label.innerHTML = label.innerHTML.replace("false", "Out of Stock");
      }
    });
  }

  // Run immediately in case Algolia has already rendered the facets
  updateStockLabels();

  // Monitor for changes (Algolia updates the DOM dynamically)
  const observer = new MutationObserver(updateStockLabels);
  observer.observe(document.body, { childList: true, subtree: true });
});
